import { render, staticRenderFns } from "./ProjectCriteriaTab.vue?vue&type=template&id=1c208b0a&"
import script from "./ProjectCriteriaTab.vue?vue&type=script&lang=ts&"
export * from "./ProjectCriteriaTab.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCriteriaTab.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports